<div>
  <div class="dialog-close">
    <span class="material-symbols-outlined" role="button" tabindex="0" (click)="closeModal()">close</span>
  </div>

  @if (!showLoadingIndicator) {
    <article class="modal-content">
      <h3>{{data.type}} Coverage Details</h3>
      @for (drug of coverageMappedToName; track drug) {
        <div class="drug-card">
          <h4>{{drug.name}} - <span class="{{drug.coverage}}">{{getCoverageHumanFriendlyLabel(drug.coverage)}}</span></h4>
          @if (drug.full_name) {
            <p>
              {{drug.full_name}}
            </p>
          }
          @if (drug.genericInfo) {
            <div>
              <h4>(Generic Alternative) - {{drug.genericInfo.name}}</h4>
              @if (drug.genericInfo.full_name !== 'LOOKUP FAILED') {
                <p>{{drug.genericInfo.full_name}}</p>
              }
            </div>
          }
        </div>
      }
      @for (provider of data.providerCoverage?.inNetwork; track provider) {
        <div class="drug-card">
          <h4>{{provider.name}} - <span class="Covered">In Network</span>
        </h4>
        <p>
          <span [innerHTML]="provider.title"></span>
          <br/>
          {{provider.address}}
        </p>
      </div>
    }
    @for (provider of data.providerCoverage?.outOfNetwork; track provider) {
      <div class="drug-card">
        <h4>{{provider.name}} - <span class="NotCovered">Out of Network</span>
      </h4>
      <p>
        <span [innerHTML]="provider.title"></span>
        <br/>
        {{provider.address}}
      </p>
    </div>
  }
</article>
} @else {
  <div class='loading-container'>
    <mat-spinner [diameter]="25"></mat-spinner>
  </div>
}

</div>
